import { render, staticRenderFns } from "./CorporationGroups.vue?vue&type=template&id=52d2bb7a&scoped=true"
import script from "./CorporationGroups.vue?vue&type=script&lang=js"
export * from "./CorporationGroups.vue?vue&type=script&lang=js"
import style0 from "./CorporationGroups.vue?vue&type=style&index=0&id=52d2bb7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d2bb7a",
  null
  
)

export default component.exports